<div class="form-input-container">

    @if (displayDirection == 'horizontal') {
    <div class="radiobox-container">
        <div style="display:flex;">
            <input type="radio" id="radiobox" name="radiobox" />
            <label for="radiobox" [hidden]="!label">{{label}}</label>
        </div>
        <div style="display:flex;">
            <input type="radio" id="radiobox2" name="radiobox" />
            <label for="radiobox2" [hidden]="!label">{{label}}</label>
        </div>
        <div style="display:flex;">
            <input type="radio" id="radiobox3" name="radiobox" />
            <label for="radiobox3" [hidden]="!label" >{{label}}</label>
        </div>
    </div> 
    }
    @if (displayDirection == 'vertical') {
        <!-- vertical radiobox -->
        <div class="radiobox-container" style="flex-direction: column; gap:5px;">
            <!-- make the label on the same height as the input -->
            <div style="display:flex;">
                <input type="radio" id="radiobox" name="radiobox" />
                <label for="radiobox" [hidden]="!label">{{label}}</label>
            </div>
            <div style="display:flex;">
                <input type="radio" id="radiobox2" name="radiobox" />
                <label for="radiobox2" [hidden]="!label">{{label}}</label>
            </div>
            <div style="display:flex;">
                <input type="radio" id="radiobox3" name="radiobox" />
                <label for="radiobox3" [hidden]="!label">{{label}}</label>
            </div>
        </div>
    }    
</div>
